// tslint:disable:max-line-length

export const IconCurrentVillage = `
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="62" height="69" viewBox="0 0 62 69">
    <defs>
        <path id="a-a" d="M20.28 45.84C8.86 44.496 0 34.783 0 23 0 10.297 10.297 0 23 0s23 10.297 23 23c0 11.782-8.86 21.495-20.28 22.84L23 54l-2.72-8.16z"/>
        <filter id="b-b" width="169.6%" height="159.3%" x="-34.8%" y="-14.8%" filterUnits="objectBoundingBox">
          <feOffset dy="8" in="SourceAlpha" result="shadowOffsetOuter1"/>
          <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="4"/>
          <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
        </filter>
    </defs>
    <g fill="none" fill-rule="evenodd" transform="translate(8)">
      <ellipse cx="23" cy="53.5" fill="#000" fill-opacity=".15" rx="5" ry="1.5"/>
      <mask id="c-c" fill="#fff">
        <use xlink:href="#a-a"/>
      </mask>
      <use fill="#000" filter="url(#b-b)" xlink:href="#a-a"/>
      <use fill="#FFF" xlink:href="#a-a"/>
      <path fill="#2B87DB" d="M23 43c11.046 0 20-8.954 20-20S34.046 3 23 3 3 11.954 3 23s8.954 20 20 20z" mask="url(#c-c)"/>
      <path fill="#FFF" d="M28.67 23.2v-4.94h-2.744v2.42L23 18l-8 7.34L17.897 28 23 23.307 28.103 28 31 25.34z" mask="url(#c-c)"/>
    </g>
  </svg>
`;
